import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import invariant from 'tiny-invariant'

export const usePhaseContractTag = (props: { phaseId: string }) => {
  const cubeCtx = useCubeContext()

  const resolvedPhase = cubeCtx.queries.resolvedPhases[props.phaseId]

  invariant(resolvedPhase, `Phase with id ${props.phaseId} not found`)

  const contractTagFeature =
    cubeCtx.queries.availableFeatures.phases[resolvedPhase.id].phase.contractTag

  return {
    available: contractTagFeature.available.enabled,
    visible: contractTagFeature.available.visible,
    contractTag: resolvedPhase.externalContractRef,
    updateContractTag: (newValue: string) => {
      cubeCtx.mutators.updateData({
        phases: {
          [props.phaseId]: {
            externalContractRef: newValue
          }
        }
      })
    },
    deleteContractTag: () => {
      cubeCtx.mutators.updateData({
        phases: {
          [props.phaseId]: {
            externalContractRef: undefined
          }
        }
      })
    }
  }
}
